export default function registration ({ to, store }) {
  const code = store.state.registration.user ? store.state.registration.user.code : false
  const routePath = to.name.includes('register') ? 'register' : 'add-child'
  if (code || to.name === `${routePath}-activation-key`) return
  return { name: `${routePath}-activation-key`, params: { ...to.params } }
}
